module.exports = __webpack_public_path__ + "img/DAI-USDC.e23e4098.png";